const scrollTriggerEl = document.querySelector('.whats-on__title--upcoming');

if (typeof scrollTriggerEl != "undefined" && scrollTriggerEl != null) {

    const whatsOnEl = document.querySelector('.whats-on__month-picker');
    const header = document.querySelector('.js-header');
    const footer = document.querySelector('.js-footer');
    const headerHeight = header.offsetHeight;

    if(scrollTriggerEl) {
        ScrollTrigger.create({
            trigger: scrollTriggerEl,
            start: `bottom ${headerHeight}`,
            endTrigger: footer, 
            end: 'top bottom',
            invalidateOnRefresh: true,
            onToggle: self => {
                if(self.isActive) {
                    whatsOnEl.classList.add('is-fixed');
                } else {
                    whatsOnEl.classList.remove('is-fixed');
                }
            }
        });
    }

    if (typeof whatsOnEl != "undefined" && whatsOnEl != null) {

        whatsOnEl.addEventListener('click', () => {
            whatsOnEl.classList.toggle('is-active');
        });        

    }

}

